import { type PointerEvent, useCallback, useRef } from 'react'

export const usePointerType = () => {
  const pointerTypeRef = useRef('mouse')

  const onPointerDownCapture = useCallback((e: PointerEvent<HTMLElement>) => {
    pointerTypeRef.current = e.pointerType
  }, [])

  const isTouch = useCallback(() => pointerTypeRef.current === 'touch', [])

  return { isTouch, onPointerDownCapture }
}
